import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  scrollValue: 0,
  scrollable: false,
  scrollDirection: "up",
};

const ScrollVariablesSlice = createSlice({
  name: "Challenge Trades",
  initialState,
  reducers: {
    setScrollValue: (state, { payload }) => {
      state.scrollValue = payload;
    },
    setScrollable: (state, { payload }) => {
      state.scrollable = payload;
    },
    setScrollDirection: (state, { payload }) => {
      state.scrollDirection = payload;
    },
  },
});
export const ScrollVariablesActions = ScrollVariablesSlice.actions;

export default ScrollVariablesSlice.reducer;
